/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StickyContainer, Sticky } from 'react-sticky';
import useQuery from '../../../util/useQuery';
import Header from './Header';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import SearchBar from '../../../components/Shared/searchbar/SearchBar';
import RiskAssessmentService from '../../../services/RiskAssessment.service';
import { RISK_REGISTER_STATUS_ID } from '../RISK_REGISTER_STATUS_ID';
import { REGISTER_ID } from '../REGISTER_ID';
import ListCardTab1 from './components/ListCardTab1';
import ListCardTab2 from './components/ListCardTab2';

import { ROUTER } from '../../../constants/router';
const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className=" "
                style={{
                    ...style,
                }}
            />
        )}
    </Sticky>
);

export default function RiskAssessmentList() {
    const navigate = useNavigate();
    const params = useQuery();
    const { t, i18n } = useTranslation();

    const btnClearRef = useRef();
    const btnClear = () => {
        if (btnClearRef && btnClearRef.current) {
            btnClearRef.current.click();
        }
    };

    //MasterData
    const [departmentList, setDepartmentList] = useState([]);
    const [statusTypeTab1, setStatusTypeTab1] = useState([]);
    const [statusTypeTab2, setStatusTypeTab2] = useState([]);
    const initialStatusTab1 = [
        REGISTER_ID.UNREGISTER,
        REGISTER_ID.IN_PROGRESS,
        REGISTER_ID.REGISTERED,
    ];
    const initialStatusTab2 = [
        RISK_REGISTER_STATUS_ID.WAITING_FOR_REVIEW, //Waiting for Review
    ];
    const [keyTab, setKeyTab] = useState(1);

    const [cardData, setCardData] = useState([]);
    const [searchValue, setSearchValue] = useState({});
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 10,
        total: 0,
    });

    const [checkedAll, setCheckedAll] = useState(false); // check Checkbox select all
    const [isCheckedAll, setIsCheckedAll] = useState(false); // check Select all {total} items in Primary
    const [select, setSelect] = useState([]); //select items ids
    const [dataSelection, setDataSelection] = useState([]);
    const [allSelection, setAllSelection] = useState([]);
    const [allDataSelection, setAllDataSelection] = useState([]);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        getDepartment();
        getStatusTab1();
        getStatusTab2();
    }, [i18n.language]);

    const getDepartment = async () => {
        try {
            let lang = i18n.language;
            const params = {
                s: lang === 'en' ? 'nameEn' : 'nameTh',
            };
            const { data } = await RiskAssessmentService.getDepartmentList(
                params
            );
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.departmentId,
                    });
                });
                setDepartmentList(option);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getStatusTab1 = async () => {
        try {
            let lang = i18n.language;
            const { data } = await RiskAssessmentService.getStatus({
                type: 'risk-register-activity',
            });
            if (data?.resultData) {
                let option = [];
                let initial = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.statusId,
                    });
                });
                option?.map((element) => initial.push(element.id));
                // setInitialStatus(initial)
                setStatusTypeTab1(option || []);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getStatusTab2 = async () => {
        try {
            let lang = i18n.language;
            const { data } = await RiskAssessmentService.getStatus({
                type: 'risk-register',
            });
            if (data?.resultData) {
                let option = [];
                let initial = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.statusId,
                    });
                });
                option?.map((element) => initial.push(element.id));
                // setInitialStatus(initial)
                setStatusTypeTab2(option || []);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const searchRiskAssessment = async (payload, pageValue) => {
        let ObjectSearch = {};
        if (!params.get('tab') || params.get('tab') === '1') {
            ObjectSearch = {
                departmentId: payload.departmentIdTab2
                    ? payload.departmentIdTab2
                    : '',
                statusIds: payload.statusTab2
                    ? payload.statusTab2.join(',')
                    : initialStatusTab2.join(','),
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
                s: 'modify_date',
                sd: 'DESC',
            };
            try {
                const { data } =
                    await RiskAssessmentService.searchRiskAssessmentRegister(
                        ObjectSearch
                    );
                setLoading(false);
                setCardData(data?.resultData?.result || []);
                setCurrentPage({
                    page: data?.resultData.page,
                    pageSize: data?.resultData.pageSize,
                    total: data?.resultData.total,
                });
            } catch (err) {
                setCurrentPage({
                    page: currentPage.page,
                    pageSize: 10,
                    total: 0,
                });
                setLoading(false);
                console.log(err);
            }
        } else {
            ObjectSearch = {
                departmentId: payload.departmentIdTab1
                    ? payload.departmentIdTab1
                    : '',
                activityName: payload.activityName ? payload.activityName : '',
                statusIds: payload.statusTab1
                    ? payload.statusTab1.join(',')
                    : initialStatusTab1.join(','),
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
                s: 'modify_date',
                sd: 'DESC',
            };
            try {
                const { data } =
                    await RiskAssessmentService.searchRiskAssessmentRopa(
                        ObjectSearch
                    );
                setLoading(false);
                setCardData(data?.resultData?.result || []);
                setCurrentPage({
                    page: data?.resultData.page,
                    pageSize: data?.resultData.pageSize,
                    total: data?.resultData.total,
                });
            } catch (err) {
                setCurrentPage({
                    page: currentPage.page,
                    pageSize: 10,
                    total: 0,
                });
                setLoading(false);
                console.log(err);
            }
        }
    };

    useEffect(() => {
        if (loading) {
            searchRiskAssessment(searchValue, currentPage);
        }
    }, [searchValue, currentPage.page, currentPage.pageSize, keyTab]);

    return (
        <>
            <div className="title ">{t('Risk Assessment')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.RiskManagement')} /{' '}
                </span>
                <span> {t('Risk Assessment List')}</span>
            </div>
            <Header />
            <div className="content_">
                <div>
                    {!params.get('tab') || params.get('tab') === '1' ? (
                        <SearchBar
                            className="w-full"
                            btnClearRef={btnClearRef}
                            loading={loading}
                            item={[
                                {
                                    label: t('dataFlow.Department'),
                                    placeholder: t('dataFlow.SelectDepartment'),
                                    name: 'departmentIdTab2',
                                    type: 'Select',
                                    option: departmentList,
                                },
                                {
                                    label: t('Status'),
                                    name: 'statusTab2',
                                    type: 'CheckboxByKey',
                                    option: statusTypeTab2,
                                    initialValue: initialStatusTab2,
                                },
                            ]}
                            onClear={() => {
                                setSelect([]);
                                setDataSelection([]);
                                setAllSelection([]);
                                setAllDataSelection([]);
                                setCheckedAll(false);
                                setLoading(true);
                                setSearchValue({
                                    statusTab2: initialStatusTab2,
                                });
                                setCurrentPage({
                                    ...currentPage,
                                    page: 1,
                                });
                            }}
                            onFinish={(e) => {
                                setSelect([]);
                                setDataSelection([]);
                                setLoading(true);
                                setSearchValue({
                                    ...e,
                                });
                                setCurrentPage({
                                    ...currentPage,
                                    page: 1,
                                });
                            }}
                        />
                    ) : (
                        <SearchBar
                            className="w-full"
                            btnClearRef={btnClearRef}
                            loading={loading}
                            item={[
                                {
                                    label: t('dataFlow.Department'),
                                    placeholder: t('dataFlow.SelectDepartment'),
                                    name: 'departmentIdTab1',
                                    type: 'Select',
                                    option: departmentList,
                                },
                                {
                                    label: t('Activity Name'),
                                    placeholder: t('Search Activity Name'),
                                    name: 'activityName',
                                    type: 'Input',
                                    option: [],
                                },
                                {
                                    label: t('Status'),
                                    name: 'statusTab1',
                                    type: 'CheckboxByKey',
                                    option: statusTypeTab1,
                                    initialValue: initialStatusTab1,
                                },
                            ]}
                            onClear={() => {
                                setLoading(true);
                                setSearchValue({
                                    statusTab1: initialStatusTab1,
                                });
                                setCurrentPage({
                                    ...currentPage,
                                    page: 1,
                                });
                            }}
                            onFinish={(e) => {
                                setLoading(true);
                                setSearchValue({
                                    ...e,
                                });
                                setCurrentPage({
                                    ...currentPage,
                                    page: 1,
                                });
                            }}
                        />
                    )}
                </div>
                <div className="w-full">
                    <div className="px-4">
                        <StickyContainer>
                            <Tabs
                                className="tabs bg-white p-4 rounded-md"
                                onChange={(key) => {
                                    setKeyTab(key);
                                    setLoading(true);
                                    btnClear();
                                    setCardData([]);
                                    navigate(
                                        `${ROUTER.RISK_MANAGEMENT.RA}?tab=${key}`
                                    );
                                }}
                                activeKey={params.get('tab') || '1'}
                                renderTabBar={renderTabBar}
                            >
                                <TabPane tab={t('RList.RiskRegister')} key={1}>
                                    <Tab2 total={currentPage?.total} />
                                </TabPane>
                                <TabPane
                                    tab={t('RA.ActivitiesRegistration')}
                                    key={2}
                                >
                                    <Tab1 total={currentPage?.total} />
                                </TabPane>
                            </Tabs>
                        </StickyContainer>
                    </div>
                    <div>
                        {!params.get('tab') || params.get('tab') === '1' ? (
                            <ListCardTab2
                                dataSource={cardData}
                                checkedAll={checkedAll}
                                setCheckedAll={setCheckedAll}
                                isCheckedAll={isCheckedAll}
                                setIsCheckedAll={setIsCheckedAll}
                                total={currentPage.total}
                                select={select}
                                setLoading={setLoading}
                                setSelect={setSelect}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                setDataSelection={setDataSelection}
                                dataSelection={dataSelection}
                                allDataSelection={allDataSelection}
                                setAllDataSelection={setAllDataSelection}
                                setAllSelection={setAllSelection}
                                allSelection={allSelection}
                            />
                        ) : (
                            <ListCardTab1
                                dataSource={cardData}
                                setLoading={setLoading}
                                total={currentPage.total}
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
